module.exports = __webpack_public_path__ + "img/outCircle.5440269a.png";